import { useEffect, useState, useCallback } from "react";

export const FEATURE_CHANGES_PROPERTIES = {
  ID: {
    KEY: "id",
  },
  STATE: {
    KEY: "validation_status",
  },
  CONFIRMED: {
    KEY: 'confirmed'
  }
};

export const useFeatureStateSync = (feature: any) => {
  const objectId = feature.get(FEATURE_CHANGES_PROPERTIES.ID.KEY);
  const [state, setState] = useState<string>(
    feature.get(FEATURE_CHANGES_PROPERTIES.STATE.KEY)
  );

  const updateState = useCallback(
    (newState: string) => {
      feature.set(FEATURE_CHANGES_PROPERTIES.STATE.KEY, newState);
      setState(newState);

      const customEvent = new CustomEvent("changeDetectionObjectState", {
        detail: {
          featureId: objectId,
          state: newState,
        },
      });
      window.dispatchEvent(customEvent);
    },
    [feature, objectId]
  );

  useEffect(() => {
    const handleExternalStateChange = (e: CustomEvent) => {
      if (e.detail.featureId !== objectId) return;
      setState(e.detail.state);
    };

    window.addEventListener(
      "changeDetectionObjectState",
      handleExternalStateChange as EventListener
    );

    return () => {
      window.removeEventListener(
        "changeDetectionObjectState",
        handleExternalStateChange as EventListener
      );
    };
  }, [feature]);

  return { state, updateState };
};
